/**
 * ProposalListPresenter
 * --
 */
import React, { useState } from 'react';
import {
  Content,
  Title,
  Row,
  Col,
  ExpandableContainer,
  Table,
  Statistic,
  ModalLayout,
  Descriptions,
} from 'components';
import {
  Button,
  DatePicker,
  Input,
  Radio,
  Select,
  message,
  Pagination,
} from 'antd';
import moment from 'moment';
import { stringToMoneyFormat } from 'utils';

const ProposalListPresenter = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  const styles = {
    title: {
      fontSize: 24,
      fontWeight: 700,
      marginBottom: 20,
    },
    button: {
      width: 80,
      height: 40,
      fontSize: 15,
      fontWeight: 600,
      margin: '0px 4px',
    },
    form: {
      input: {
        large: {
          width: 175,
          marginRight: 8,
        },
        medium: {
          width: 100,
          marginRight: 8,
        },
      },
      button: {
        marginRight: 8,
      },
      date: {
        width: 120,
      },
      text: {
        fontSize: 13,
        fontWeight: 400,
      },
    },
  };

  const formItem = [
    {
      label: '검색어',
      direction: 'column',
      form: [
        {
          input: (
            <>
              <Select
                size="large"
                value={'상품명'}
                options={[
                  { label: '상품명', value: '상품명' },
                  { label: '회원명', value: '회원명' },
                  { label: '전화번호', value: '전화번호' },
                ]}
                style={{ ...styles.form.input.large }}
              />
              <Input
                size="large"
                placeholder="검색어를 입력해주세요"
                style={{ ...styles.form.input.large, width: 350 }}
              />
            </>
          ),
        },
      ],
    },
    {
      label: '기간',
      form: [
        {
          input: (
            <>
              <Select
                size="large"
                style={{ ...styles.form.input.large }}
                placeholder="혜택등록일"
              />
            </>
          ),
        },
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              오늘
            </Button>
          ),
        },
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              1주일
            </Button>
          ),
        },
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              1개월
            </Button>
          ),
        },
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              3개월
            </Button>
          ),
        },
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              전체
            </Button>
          ),
        },
        {
          input: (
            <>
              <DatePicker
                size="large"
                format={'YYYY-MM-DD'}
                placeholder=""
                style={{ ...styles.form.date }}
              />
              <p style={{ ...styles.form.text, padding: '0px 2px' }}>~</p>
              <DatePicker
                size="large"
                format={'YYYY-MM-DD'}
                placeholder=""
                style={{ ...styles.form.date }}
              />
            </>
          ),
        },
      ],
    },
    {
      label: '적립금액',
      form: [
        {
          input: (
            <>
              <Input
                size="large"
                placeholder="숫자만 입력"
                style={{ ...styles.form.date }}
              />
              <p style={{ ...styles.form.text, padding: '0px 2px' }}>~</p>
              <Input
                size="large"
                placeholder="숫자만 입력"
                style={{ ...styles.form.date }}
              />
              <p style={{ ...styles.form.text, padding: '0px 2px' }}>원</p>
            </>
          ),
        },
      ],
    },
    {
      label: '할인금액',
      form: [
        {
          input: (
            <>
              <Input
                size="large"
                placeholder="숫자만 입력"
                style={{ ...styles.form.date }}
              />
              <p style={{ ...styles.form.text, padding: '0px 2px' }}>~</p>
              <Input
                size="large"
                placeholder="숫자만 입력"
                style={{ ...styles.form.date }}
              />
              <p style={{ ...styles.form.text, padding: '0px 2px' }}>원</p>
            </>
          ),
        },
      ],
    },
    {
      label: '쿠폰 발행 여부',
      form: [
        {
          input: (
            <>
              <Radio.Group value={'발행함'}>
                <Radio value={'발행함'}>발행함</Radio>
                <Radio value={'발행 안함'}>발행 안함</Radio>
              </Radio.Group>
            </>
          ),
        },
      ],
    },
    {
      label: '프로모션 진행 여부',
      form: [
        {
          input: (
            <>
              <Radio.Group value={'진행함'}>
                <Radio value={'진행함'}>진행함</Radio>
                <Radio value={'진행 안함'}>진행 안함</Radio>
              </Radio.Group>
            </>
          ),
        },
      ],
    },
    {
      label: '상품 분류',
      form: [
        {
          input: (
            <>
              <Select
                size="large"
                options={[
                  { label: '대분류1', value: '대분류1' },
                  { label: '대분류2', value: '대분류2' },
                  { label: '대분류3', value: '대분류3' },
                ]}
                style={{ ...styles.form.input.large }}
                placeholder={'대분류 선택'}
              />
              <Select
                size="large"
                options={[
                  { label: '중분류1', value: '중분류1' },
                  { label: '중분류2', value: '중분류2' },
                  { label: '중분류3', value: '중분류3' },
                ]}
                style={{ ...styles.form.input.large }}
                placeholder={'중분류 선택'}
              />
              <Select
                size="large"
                options={[
                  { label: '소분류1', value: '소분류1' },
                  { label: '소분류2', value: '소분류2' },
                  { label: '소분류3', value: '소분류3' },
                ]}
                style={{ ...styles.form.input.large }}
                placeholder={'소분류 선택'}
              />
              <Select
                size="large"
                options={[
                  { label: '상세분류1', value: '상세분류1' },
                  { label: '상세분류2', value: '상세분류2' },
                  { label: '상세분류3', value: '상세분류3' },
                ]}
                style={{ ...styles.form.input.large }}
                placeholder={'상세분류 선택'}
              />
            </>
          ),
        },
      ],
    },
  ];

  // NOTE: 테이블 가짜 데이터
  const [newData, setNewData] = useState([
    {
      프로모션명: '여름 할인 이벤트',
      업체명: 'abc커피',
      프로모션코드: '',
      적립수치: 2000,
      할인수치: 2000,
      쿠폰여부: '-',
      시작일: moment(),
      종료일: moment(),
      심사상태: '신청',
      내용: '프로모션 내용입니다. 프로모션 내용입니다. 프로모션 내용입니다. 프로모션 내용입니다. 프로모션 내용입니다. 프로모션 내용입니다. 프로모션 내용입니다. 프로모션 내용입니다. 프로모션 내용입니다. 프로모션 내용입니다. 프로모션 내용입니다. 프로모션 내용입니다. 프로모션 내용입니다. 프로모션 내용입니다. 프로모션 내용입니다. 프로모션 내용입니다. 프로모션 내용입니다. 프로모션 내용입니다. 프로모션 내용입니다. 프로모션 내용입니다. 프로모션 내용입니다. 프로모션 내용입니다. 프로모션 내용입니다. 프로모션 내용입니다.',
    },
  ]);

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedPromotion, setSelectedPromotion] = useState(null);
  const [rejectionReason, setRejectionReason] = useState('');

  // 심사 버튼 클릭 핸들러
  const handleAudit = (record) => {
    setSelectedPromotion(record);
    setIsModalVisible(true);
  };

  // 승인 버튼 클릭 핸들러
  const handleApprove = () => {
    message.success('승인되었습니다.');
    setNewData((prevData) =>
      prevData.map((item) =>
        item === selectedPromotion ? { ...item, 심사상태: '승인' } : item
      )
    );
    setIsModalVisible(false);
  };

  // 거부 버튼 클릭 핸들러
  const handleReject = () => {
    if (!rejectionReason.trim()) {
      // 거부 사유가 없을 때 경고 메시지 표시
      message.warning('거부 사유를 입력하세요.');
      return;
    }
    message.error('거부되었습니다.');
    setNewData((prevData) =>
      prevData.map((item) =>
        item === selectedPromotion ? { ...item, 심사상태: '거부' } : item
      )
    );
    setIsModalVisible(false);
  };

  // 모달 닫기 핸들러
  const handleCancel = () => {
    setIsModalVisible(false);
    setRejectionReason('');
  };

  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <Content maxWidth={'100%'} padding={20} backgroundColor={'none'}>
      <Row>
        <Col x={24}>
          <Title style={{ ...styles.title }}>프로모션 제안 목록</Title>

          {/* 요약 */}
          <Content
            maxWidth={'100%'}
            padding={0}
            backgroundColor={'none'}
            style={{ marginBottom: 40 }}
          >
            <Row gutter={20}>
              <Col x={12}>
                <Content maxWidth={'100%'} padding={0} backgroundColor="none">
                  <div>
                    <div
                      style={{
                        padding: '10px 16px',
                        background: '#E1E2E4',
                        borderTopRightRadius: 4,
                        borderTopLeftRadius: 4,
                      }}
                    >
                      <h4 style={{ fontSize: 13, fontWeight: 500 }}>
                        진행중인 프로모션
                      </h4>
                    </div>
                    <div
                      style={{
                        borderBottomLeftRadius: 4,
                        borderBottomRightRadius: 4,
                        background: '#FFFFFF',
                      }}
                    >
                      <Table
                        minHeight={260}
                        columns={[
                          {
                            title: '혜택유형',
                            key: '혜택유형',
                          },
                          {
                            title: '혜택명',
                            key: '혜택명',
                          },
                          {
                            title: '시작일',
                            key: '시작일',
                            render: (item) =>
                              moment(item).format('YYYY-MM-DD HH:mm'),
                          },
                          {
                            title: '종료일',
                            key: '종료일',
                            render: (item) =>
                              moment(item).format('YYYY-MM-DD HH:mm'),
                          },
                        ]}
                        data={
                          [
                            // {
                            //   혜택유형: '기간할인',
                            //   혜택명: '런칭할인',
                            //   시작일: new Date(),
                            //   종료일: new Date(),
                            // },
                          ]
                        }
                      />
                    </div>
                  </div>
                </Content>
              </Col>
              <Col x={12}>
                <Content maxWidth={'100%'} padding={0} backgroundColor="none">
                  <div>
                    <div
                      style={{
                        padding: '10px 16px',
                        background: '#E1E2E4',
                        borderTopRightRadius: 4,
                        borderTopLeftRadius: 4,
                      }}
                    >
                      <h4 style={{ fontSize: 13, fontWeight: 500 }}>
                        발급중인 쿠폰 현황
                      </h4>
                    </div>
                    <div
                      style={{
                        borderBottomLeftRadius: 4,
                        borderBottomRightRadius: 4,
                        background: '#FFFFFF',
                      }}
                    >
                      <Table
                        minHeight={260}
                        columns={[
                          {
                            title: '혜택유형',
                            key: '혜택유형',
                          },
                          {
                            title: '쿠폰명',
                            key: '쿠폰명',
                          },
                          {
                            title: '사용기간',
                            key: '사용기간',
                            render: (item) =>
                              moment(item).format('YYYY-MM-DD HH:mm'),
                          },
                        ]}
                        empty={
                          <p style={{ fontSize: 13, fontWeight: 400 }}>
                            발급중인 쿠폰이 없습니다.
                          </p>
                        }
                      />
                    </div>
                  </div>
                </Content>
              </Col>
            </Row>
          </Content>
          {/* 요약 끝 */}

          {/* 검색필터 */}
          <Content
            maxWidth={'100%'}
            padding={0}
            backgroundColor={'none'}
            style={{ marginBottom: 40 }}
          >
            <ExpandableContainer borderRadius={4} padding={20}>
              {formItem.map((_item, _index) => (
                <div
                  key={`form_${_index}`}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    padding: '10px 0px',
                  }}
                >
                  <div style={{ width: 120, fontSize: 13, fontWeight: 400 }}>
                    <label>{_item.label}</label>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    {_item.form.map((_subitem, _subkey) => (
                      <React.Fragment key={`input_${_subkey}`}>
                        {_subitem.input}
                      </React.Fragment>
                    ))}
                  </div>
                </div>
              ))}
            </ExpandableContainer>

            {/* 검색/초기화 버튼 */}
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                marginTop: 48,
              }}
            >
              <Button
                size="large"
                type="primary"
                style={{
                  ...styles.button,
                  background: 'var(--primary-color)',
                }}
              >
                검색
              </Button>
              <Button size="large" style={{ ...styles.button }}>
                초기화
              </Button>
            </div>
            {/* 검색/초기화 버튼 끝 */}
          </Content>
          {/* 검색필터 끝 */}

          {/* 검색결과 */}
          <Content maxWidth={'100%'} borderRadius={4} padding={20}>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                marginBottom: 20,
                justifyContent: 'space-between',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <h4 style={{ fontSize: 14, fontWeight: 500, marginRight: 20 }}>
                  총 <span>0</span>건
                </h4>
                {/* <Button
                  size="large"
                  style={{ marginRight: 8 }}
                  //onClick={() => navigate('')}
                >
                  프로모션 추가
                </Button>
                <Button size="large" style={{ marginRight: 8 }}>
                  선택삭제
                </Button> */}
              </div>
              <div>
                <Select
                  size="large"
                  value={'등록일순'}
                  options={[
                    { label: '등록일순', value: '등록일순' },
                    { label: '등록일순2', value: '등록일순2' },
                  ]}
                />
              </div>
            </div>
            <Table
              data={newData}
              isChecked
              columns={[
                {
                  title: '프로모션명',
                  key: '프로모션명',
                },
                {
                  title: '프로모션코드',
                  key: '프로모션코드',
                },
                {
                  title: '적립 수치',
                  key: '적립수치',
                  render: (item) => stringToMoneyFormat(item, '원'),
                },
                {
                  title: '할인 수치',
                  key: '할인수치',
                  render: (item) => stringToMoneyFormat(item, '원'),
                },
                {
                  title: '쿠폰여부(쿠폰수량)',
                  key: '쿠폰여부',
                },
                {
                  title: '혜택 시작일',
                  key: '시작일',
                  render: (item) => moment(item).format('YYYY-MM-DD HH:mm'),
                },
                {
                  title: '혜택 종료일',
                  key: '종료일',
                  render: (item) => moment(item).format('YYYY-MM-DD HH:mm'),
                },
                {
                  title: '진행여부',
                  key: '심사상태',
                },
                {
                  title: '심사',
                  key: '심사',
                  render: (_, record) => {
                    const isSubmitted = record.심사상태 === '신청';

                    return (
                      <Button
                        size="small"
                        style={{
                          borderColor: isSubmitted
                            ? 'var(--primary-color)'
                            : '#d9d9d9',
                          color: isSubmitted
                            ? 'var(--primary-color)'
                            : '#bfbfbf',
                          cursor: isSubmitted ? 'pointer' : 'unset',
                        }}
                        onClick={() => handleAudit(record)} // 모든 상태에서 클릭 시 모달이 열림
                        //disabled={!isSubmitted} // '신청' 상태일 때만 활성화
                      >
                        {isSubmitted ? '심사' : '수정'}
                      </Button>
                    );
                  },
                },
              ]}
            />
          </Content>
          {/* 검색결과 끝 */}

          <ModalLayout
            isOpen={isModalVisible}
            open={isModalVisible}
            title="프로모션 심사"
            closable={true}
            onCancel={handleCancel}
            footer={
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <Button type="primary" onClick={handleApprove}>
                  승인
                </Button>
                <Button
                  style={{
                    backgroundColor: rejectionReason.trim()
                      ? '#1890ff'
                      : '#f5f5f5',
                    color: rejectionReason.trim() ? '#fff' : '#ccc',
                    borderColor: rejectionReason.trim() ? '#1890ff' : '#d9d9d9',
                    cursor: rejectionReason.trim() ? 'pointer' : 'unset',
                  }}
                  onClick={handleReject}
                >
                  거부
                </Button>
              </div>
            }
          >
            <Content maxWidth={'100%'} padding={'30px 0px'}>
              <Row>
                <Col x={24}>
                  <Content maxWidth={'100%'} padding={0}>
                    <Descriptions
                      items={[
                        {
                          key: '프로모션명',
                          label: '프로모션명',
                          children: <>{selectedPromotion?.프로모션명}</>,
                          span: 2,
                        },
                        {
                          key: '업체명',
                          label: '업체명',
                          children: <>{selectedPromotion?.업체명}</>,
                        },
                        {
                          key: '기간',
                          label: '기간',
                          children: (
                            <>
                              {moment().format('YYYY-MM-DD HH:mm')}~
                              {moment().format('YYYY-MM-DD HH:mm')}
                            </>
                          ),
                        },
                        {
                          key: '할인수치',
                          label: '할인수치',
                        },
                        {
                          key: '적립수치',
                          label: '적립수치',
                        },
                        {
                          label: '쿠폰여부(쿠폰수량)',
                          key: '쿠폰여부',
                        },
                        {
                          key: '포인트',
                          label: '포인트',
                        },
                        {
                          key: '내용',
                          label: '내용',
                          children: (
                            <div style={{ padding: '20px' }}>
                              {selectedPromotion?.내용}
                            </div>
                          ),
                          span: 2,
                        },
                      ]}
                    />
                    <Input.TextArea
                      rows={4}
                      placeholder="거부 사유를 입력하세요."
                      value={rejectionReason}
                      onChange={(e) => setRejectionReason(e.target.value)}
                      style={{ marginTop: 10 }}
                    />
                  </Content>
                </Col>
              </Row>
            </Content>
          </ModalLayout>
        </Col>
      </Row>
    </Content>
  );
};

export default ProposalListPresenter;
